import React from 'react';

/**
 * A reusable candidate card component that displays candidate information.
 * Designed to match Figma specs: 249px × 355px with 16px border radius.
 */
function CandidateCard({
  image,
  name,
  experience = "",
  recommendations = "",
  candidateId = "",
  isStarCandidate = true,
  className = ""
}) {
  // Helper function to combine classNames, similar to the cn utility in Next.js
  const combineClasses = (...classes) => {
    return classes.filter(Boolean).join(' ');
  };

  return (
    <div
      className={combineClasses(
        "w-[249px] h-[355px] relative overflow-hidden rounded-2xl border-2 border-gray-100 shadow-md hover:shadow-lg transition-all",
        className
      )}
    >
      {/* Background Image */}
      <div className="absolute inset-0 bg-black z-0">
        {image ? (
          <img
            src={image || "/placeholder.svg"}
            alt={`${name} profile photo`}
            className="w-full h-full object-cover"
            draggable={false}
            style={{ display: 'block' }}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gray-100">
            <div className="h-16 w-16 rounded-full bg-[#FF8C00] flex items-center justify-center text-white">
              <span className="text-2xl font-medium">{name.charAt(0)}</span>
            </div>
          </div>
        )}
      </div>

      {/* Star Candidate Label */}
      {isStarCandidate && (
        <div className="absolute top-0 left-0 right-0 z-10">
          <div className="bg-[#FF8C00] text-white py-2 px-4 flex items-center justify-center gap-1 rounded-t-2xl">
            <span className="text-yellow-200 text-sm">★</span>
            <span className="text-sm font-medium">Star Candidate</span>
            <span className="text-yellow-200 text-sm">★</span>
          </div>
        </div>
      )}

      {/* Candidate Info Overlay */}
      <div className="absolute bottom-0 left-0 right-0 p-4 pb-6 text-white bg-gradient-to-t from-black/90 via-black/70 to-transparent">
        <div className="space-y-1">
          <h3 className="text-lg font-bold truncate">{name}</h3>
          {experience && <p className="text-sm font-medium truncate">{experience}</p>}
          {recommendations && <p className="text-sm font-medium truncate">{recommendations}</p>}
        </div>
      </div>
    </div>
  );
}

export default CandidateCard;
